import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { esDiaHabil, hoyDelPais, parseLocalYMD, toLocalYMD } from "../../utils/fechasFuturosPanel";
import { MODOS_VALIDACION } from "../../utils/validarFechaDocumento";

// Componente compartido de calendario de fecha para los caminos de "Futuros: reagendar" (Fase 5,
// Commit 2b, 2026-09-26 — decisión de Ignacio: las ventanas tienen que deshabilitar en el CALENDARIO
// los mismos días que el writer va a rechazar, no solo avisar después de intentar guardar). Extraído
// de `FlujoCajaV2/CeldaFechaReagendable.js` (el click en la celda del panel Futuros) para que TODOS
// los caminos usen el MISMO calendario (10.1) — nunca un `<input type="date">` nativo del navegador,
// que no sabe deshabilitar nada.
//
// Regla de la fase (ver docs/decisiones/2026-09-26-fase-5-diseno-unificacion-fechas.md §3): cada
// modal que se migra en la §10 reemplaza su input de fecha por ESTE componente, con el modo
// (`MODOS_VALIDACION`) que le corresponde según el diseño — nunca reimplementa qué día deshabilitar.
//
// `calcularRestriccionesFecha` es la parte PURA (sin JSX/DOM), exportada aparte para poder testearla
// sin renderizar React — el proyecto no tiene `@testing-library/react` instalado (mismo motivo que
// `aplicarPatchYToast` en CeldaFechaReagendable.js).
//
// @param {"estricto"|"dato_documento"} modo - uno de MODOS_VALIDACION.
// @param {string} pais - "Chile"|"Perú" (10.53). Solo se usa en modo ESTRICTO.
// @returns {{minDate: Date|undefined, filterDate: ((d: Date) => boolean)|undefined}} — ambos
//   `undefined` en modo DATO_DOCUMENTO (ningún día deshabilitado, react-datepicker los trata igual
//   que si no se pasaran).
export const calcularRestriccionesFecha = ({ modo, pais }) => {
  if (modo !== MODOS_VALIDACION.ESTRICTO) {
    return { minDate: undefined, filterDate: undefined };
  }
  // Mismo criterio EXACTO que CeldaFechaReagendable.js (10.1): piso hoyDelPais(pais) (huso REAL del
  // país operativo, nunca el del navegador) + día hábil (esDiaHabil, fechasFuturosPanel.js) — ninguna
  // lógica de "qué día deshabilitar" se reimplementa acá.
  const hoyMedianoche = parseLocalYMD(hoyDelPais(pais));
  return {
    minDate: hoyMedianoche,
    filterDate: (d) => d >= hoyMedianoche && esDiaHabil(toLocalYMD(d)),
  };
};

/**
 * @param {string|null} value - "YYYY-MM-DD", o null/vacío.
 * @param {(nuevaFecha: string|null) => void} onChange - recibe "YYYY-MM-DD" (o null si se limpia).
 * @param {string} pais - "Chile"|"Perú" (10.53). Requerido en modo ESTRICTO.
 * @param {"estricto"|"dato_documento"} [modo] - default ESTRICTO (MODOS_VALIDACION).
 */
const SelectorFechaDocumento = ({ value, onChange, pais, modo = MODOS_VALIDACION.ESTRICTO, disabled, ...rest }) => {
  const { minDate, filterDate } = calcularRestriccionesFecha({ modo, pais });
  return (
    <DatePicker
      selected={parseLocalYMD(value)}
      onChange={(date) => onChange(date ? toLocalYMD(date) : null)}
      minDate={minDate}
      filterDate={filterDate}
      dateFormat="dd/MM/yyyy"
      className="form-control"
      placeholderText="dd/mm/aaaa"
      disabled={disabled}
      {...rest}
    />
  );
};

export default SelectorFechaDocumento;
